import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faFilePdf} from '@netx/core-icons';
import {canCreatePdfFromAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';
import {assetActionCreatePDFDownload} from './asset-create-pdf-download';
import {assetActionCreatePDFShare} from './asset-create-pdf-share-link';

export const assetActionCreatePDFIcon = faFilePdf;

/**
 * Create pdf from asset
 * @param params
 * @returns Action
 */
export const assetActionCreatePDF = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-create-pdf',
	cb: () => {}, //dispatcher.trigger(ASSET_EVENT.CREATE_PDF, asset),
	// enableTest: () => canCreatePdfFromAsset(asset),
	icon: assetActionCreatePDFIcon,
	get label() {
		return AssetActionLabel.CREATE_PDF;
	},
	children: [
		assetActionCreatePDFDownload(asset),
		assetActionCreatePDFShare(asset),
	],
	...params,
});

export default assetActionCreatePDF;
